<div class="pb-2 text-xl leading-none font-semibold tracking-tight">Historique des sessions</div>

@for (userSession of userSessions(); track $index) {
  <div class="flex justify-between gap-2">
    <div class="flex gap-4">
      <mat-icon class="h-8 w-8 self-center text-4xl">
        {{
          userSession.userAgent.device === 'console'
            ? 'sports_esports'
            : userSession.userAgent.device === 'embedded'
              ? 'memory'
              : userSession.userAgent.device === 'mobile'
                ? 'smartphone'
                : userSession.userAgent.device === 'smarttv'
                  ? 'tv'
                  : userSession.userAgent.device === 'tablet'
                    ? 'tablet_mac'
                    : userSession.userAgent.device === 'wearable'
                      ? 'watch'
                      : userSession.userAgent.device === 'xr'
                        ? 'view_in_ar'
                        : 'desktop_windows'
        }}
      </mat-icon>
      <div class="flex flex-col">
        <div class="text-lg font-medium">{{ userSession.userAgent.device }}</div>
        <div class="text-md font-medium">{{ userSession.userAgent.location }}</div>
        <div>
          Session créée le {{ userSession.createdAt | luxonDate: 'dd LLLL yyyy' }} à
          {{ userSession.createdAt | luxonDate: 'HH:mm' }}
        </div>
        <div>
          Dernière connexion le {{ userSession.lastLoginAt | luxonDate: 'dd LLLL yyyy' }} à
          {{ userSession.lastLoginAt | luxonDate: 'HH:mm' }}
        </div>
      </div>
    </div>
    <div class="content-center">
      @if (userSession.isCurrentSession) {
        <div class="rounded-md bg-grass-6 px-2 py-1 font-semibold">Session en cours</div>
      } @else {
        <button (click)="revokeSession.emit(userSession._id)" class="link destructive w-full" mat-button>
          <span> Se déconnecter </span>
        </button>
      }
    </div>
  </div>
  <mat-divider class="my-4" />
}
<div class="pb-4">
  <button class="primary destructive w-full" (click)="revokeAllSession.emit()" mat-button>
    Déconnecter toutes les sessions
  </button>
</div>
